import { useEffect, useState } from 'react';
// import Popup from 'reactjs-popup';
import { Markup } from 'interweave';

import Title from '../shared/Title';
import './Curriculum.css';
// import Description from '../shared/Description';
import backGroundCuriculum from '../../assets/images/curriculum/Background_Chuong_trinh_dao_tao.png';
// import ContentModal from '../shared/PopUpModal';

import { apispreadsheets, imgFromDriveUrl } from '../shared/ApiSpreadSheets';
import { SHEET_NAMES } from '../../constants/sheets';

function Curriculum() {
  const [menuCurrent, setMenuCurrent] = useState(0);
  const animationConfig = { animationName: 'curriculumDetail', animationDuration: '0.6s', timeout: 1000 };

  const [effectCurriculumDetailDuration, setEffectCurriculumDetailDuration] = useState(
    `${animationConfig.animationName} ${animationConfig.animationDuration}`,
  );

  // Check is Mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth < 845);
  const isMobileController = () => {
    setIsMobile(window.innerWidth < 1280);
  };
  // const exceptionHeightSrceen = () => {
  //   if (window.innerHeight >= 905) {
  //     bgShortDescription.current.style.backgroundSize = "cover";
  //   } else {
  //     bgShortDescription.current.style.backgroundSize = "";
  //   }
  // };

  useEffect(() => {
    // exceptionHeightSrceen();
    window.addEventListener('resize', isMobileController);
    // window.addEventListener('resize', exceptionHeightSrceen);

    return () => {
      window.removeEventListener('resize', isMobileController);
      // window.removeEventListener('resize', exceptionHeightSrceen);
    };
  }, []);

  const [isLoaded, setIsLoaded] = useState(false);
  const [sheets, setSheets] = useState([]);
  // const bgShortDescription = useRef();

  // const NGANH_2_MOCK = {
  //   chuong_trinh: "Ngành 2",
  //   mo_ta: "Nội dung ngành 2 đang được cập nhật",
  //   hoc_ky: "Học kỳ 1",
  //   anh_project1: "",
  //   isMock: true,
  // };

  function normalizeCurriculumData(rows) {
    const result = [];
    let currentProgram = null;

    rows.forEach(row => {
      // Gặp dòng có tên ngành → tạo chương trình mới
      if (row.nganh && row.nganh.trim() !== "" && row.year == "2026") {
        currentProgram = {
          ten_chuong_trinh: "Ngành " + row.nganh,
          year: row.year,
          mo_ta: row.mo_ta || "",
          hoc_ky_list: [],
        };
        result.push(currentProgram);
      }

      // Gặp dòng học kỳ → nhét vào chương trình hiện tại
      if (currentProgram && row.hoc_ky) {
        currentProgram.hoc_ky_list.push({
          hoc_ky: row.hoc_ky,
          anh_project1: row.anh_project1 || "",
          anh_project2: row.anh_project2 || "",
          tieu_de_gioi_thieu_ngan: row.tieu_de_gioi_thieu_ngan || "",
        });
        // console.log(currentProgram);
      }
    });

    const priorityOrder = [
      "MỸ THUẬT ĐA PHƯƠNG TIỆN QUỐC TẾ",
      "HOẠT HÌNH GAME 3D VÀ NGHỆ THUẬT GAME NÂNG CAO"
    ];

    result.sort((a, b) => {
      const aIndex = priorityOrder.indexOf(a.ten_chuong_trinh);
      const bIndex = priorityOrder.indexOf(b.ten_chuong_trinh);

      // Cả hai đều nằm trong danh sách ưu tiên
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }

      // Chỉ a nằm trong ưu tiên → a lên trước
      if (aIndex !== -1) return -1;

      // Chỉ b nằm trong ưu tiên → b lên trước
      if (bIndex !== -1) return 1;

      // Không ưu tiên → giữ nguyên thứ tự
      return 0;
    });

    // console.log(result);
    return result;
  }


  // FETCH DATA AND SET STATUS
  useEffect(() => {
    const sheetName = SHEET_NAMES.CHUONG_TRINH_DAO_TAO;
    fetch(`${apispreadsheets}/${sheetName}`)
      .then((res) => res.json())
      .then(
        (results) => {
          const normalized = normalizeCurriculumData(results);
          setSheets(normalized);

          // const nganh1 = {
          //   ten_chuong_trinh: "MỸ THUẬT ĐA PHƯƠNG TIỆN QUỐC TẾ",
          //   hoc_ky_list: results,
          //   mo_ta: "Chương trình đào tạo toàn diện về sáng tạo hình ảnh và nội dung số. Sinh viên được chuẩn hóa năng lực từ tư duy thiết kế, thẩm mỹ đến kỹ năng thực chiến chuyên nghiệp. Từ đó, làm chủ các lĩnh vực như thiết kế 2D, UI/UX, kỹ xảo điện ảnh và hoạt hình 3D, đáp ứng nhu cầu đa dạng của thị trường sáng tạo số. Với chương trình học mang tầm quốc tế, sinh viên có thể phát triển toàn diện Portfolio thông qua các dự án thực tế, mở ra các cơ hội nghề nghiệp hấp dẫn. Xây dựng hành trang vững vàng với lộ trình 2 năm tại CUSC ARENA tốt nghiệp bằng ADIM (ADVANCED DIPLOMA IN MULTIMEDIA) do Tập đoàn CNTT Aptech Ấn Độ cấp.",
          // };

          // const hocKyKhongAnh = ["HỌC KỲ 2", "HỌC KỲ 3", "HỌC KỲ 4"];

          // const nganh2 = {
          //   ten_chuong_trinh: "HOẠT HÌNH GAME 3D VÀ NGHỆ THUẬT GAME NÂNG CAO",
          //   mo_ta: "Chương trình đào tạo chuyên sâu về Game và Hoạt hình 3D,  ứng dụng công nghệ Real-time (thời gian thực) và tích hợp trí tuệ nhân tạo tạo sinh (Generative AI) vào quy trình sản xuất. Sinh viên được trang bị kiến thức, kỹ năng từ giai đoạn tiền kỳ sáng tạo, diễn hoạt nhân vật đến xây dựng thế giới ảo và sản phẩm game theo chuẩn studio chuyên nghiệp. Chương trình chuẩn hóa năng lực kỹ thuật bậc cao cho các dây chuyền sản xuất Game AAA và hoạt hình 3D quốc tế. Lộ trình 02 năm tối ưu giúp bạn đạt được bằng Advanced Diploma (AD3DAGA) do Tập đoàn CNTT Aptech Ấn Độ cấp, mở cánh cửa sự nghiệp chuyên gia tại các tập đoàn lớn trong và ngoài nước.",
          //   hoc_ky_list: results.map(item => ({
          //     ...item,
          //     anh_project1: hocKyKhongAnh.includes(item.hoc_ky)
          //       ? ""
          //       : item.anh_project1,
          //     tieu_de_gioi_thieu_ngan: `${item.tieu_de_gioi_thieu_ngan} (Ngành 2)`,
          //     isMock: true,
          //   })),
          // };

          // setSheets([nganh1, nganh2]);
          // console.log('sheets:', sheets);

          setIsLoaded(true);

          // console.log('FINAL DATA:', [nganh1, nganh2]);
          // console.log('FINAL DATA:', normalized);
        },
        (error) => {
          // console.log('error: ', error);
          setIsLoaded(false);
        },
      );
  }, []);

  // WHEN CLICK FUNCTION HANDLE GetDataCuriculum
  const handleGetDataCuriculum = (index) => {
    setMenuCurrent(index);

    if (!isMobile) {
      setEffectCurriculumDetailDuration(`${animationConfig.animationName} ${animationConfig.animationDuration}`);
      setTimeout(() => {
        setEffectCurriculumDetailDuration('none');
      }, animationConfig.timeout);
    }
  };

  const contentStyle = {
    maxWidth: '900px',
    width: '95%',
  };


  // state cho chương trình đang chọn
  const [programCurrent, setProgramCurrent] = useState(1);
  const [semesterCurrent, setSemesterCurrent] = useState(0);

  return (
    <>
      <div className="w-[100%] h-[1280px] xl:h-[1380px] relative">
        <div
          className="scale-x-[-1] w-[100%] bg-curriculum bg-auto md:bg-cover bg-no-repeat"
          style={{
            backgroundImage: `url(${backGroundCuriculum})`,
            // backgroundPosition: `top center`,
          }}

        >
          <div className="scale-x-[-1] relative px-5 xl:px-80">
            <Title className="mt-48 md:mt-[400px] lg:mt-[420px] text-center">Chương trình đào tạo</Title>
            {/* <Description className="mt-5 text-justify md:text-center font-medium">
              <Markup
                allowAttributes
                content={isLoaded && sheets[0].hoc_ky_list[0].mo_ta}
              />
            </Description> */}

            <div className="flex justify-center mt-6 gap-8">
              {sheets[programCurrent] && (
                <h3 className="text-[#723091] md:text-2xl font-bold uppercase">
                  {sheets[programCurrent].ten_chuong_trinh}
                </h3>
              )}
            </div>

            <div className="mt-5 text-justify md:text-center font-medium">
              <Markup
                allowAttributes
                content={isLoaded ? sheets[programCurrent].mo_ta : ''}
              />
            </div>

            {/* Begin Tab Menu */}
            <div className="flex max-w-[70%] mx-auto text-white mt-4 justify-center cursor-pointer">
              {sheets.map((data, index) => (
                <div
                  key={index}
                  className={`mr-5 md:mr-6 min-w-fit ${menuCurrent == index ? 'menu-active' : ''}`}
                  onClick={() => handleGetDataCuriculum(index)}
                >
                  {data.hoc_ky}
                </div>
              ))}
            </div>

            {/* End Tab Menu */}
          </div>

          <div className="scale-x-[-1] flex max-w-[70%] mx-auto text-black mt-4 justify-center cursor-pointer">
            {sheets[programCurrent]?.hoc_ky_list?.map((hocKy, index) => (
              <div
                key={index}
                className={`mr-5 md:mr-6 min-w-fit ${semesterCurrent === index ? "menu-active" : ""
                  }`}
                onClick={() => setSemesterCurrent(index)}
              >
                {hocKy.hoc_ky}
              </div>
            ))}
          </div>

          {/* BEGIN CONTENT CURRICULUM */}
          <div className="scale-x-[-1] mt-5 sm:mt-6">
            {isLoaded && (
              <div className="flex justify-center">
                <img
                  className="content__img"
                  src={imgFromDriveUrl(
                    sheets[programCurrent]
                      ?.hoc_ky_list[semesterCurrent]
                      ?.anh_project1
                  )}
                  alt=""
                />
              </div>
            )}
          </div>

        </div>
      </div >

    </>
  );
}

export default Curriculum;
